import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'src/store/auth-context';
import { AdminAuthProvider } from 'src/store/admin-auth-context';
import ToastContext from 'src/store/toast-context';
import { ThemeProvider } from '@mui/material/styles';
import { AppProvider } from 'src/store/app-context';
import customTheme from 'src/styles/theme.js';
import config from 'src/config';
import 'src/styles/app.scss';
import 'react-toastify/dist/ReactToastify.min.css';

import { ToastContainer, toast } from 'react-toastify';
const toastValues = {
  dark: toast.dark,
  default: toast,
  error: (e) => {
    toast.dismiss();

    toast.error(e);
  },
  info: toast.info,
  success: toast.success,
  warning: toast.warning,
  handleError: (e) => {
    let errorMessage = '';
    if (e.response) {
      errorMessage = e.response?.data.message ?? e.response?.data ?? 'Something went wrong';
      if (e.response.status === 400) {
        errorMessage = e.response?.data.statusText ?? 'Something went wrong';
      }
    } else {
      errorMessage = e.message ?? 'Could not connect to server';
    }

    // Dismiss all active toasts
    toast.dismiss();

    toast.error(errorMessage);
  },
};

ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={customTheme}>
      <ToastContext.Provider value={toastValues}>
        <ToastContainer containerId="toast-container" limit={3} />
        <BrowserRouter basename={config.basePath}>
          <AuthProvider>
            <AdminAuthProvider>
              <AppProvider>
                <App />
              </AppProvider>
            </AdminAuthProvider>
          </AuthProvider>
        </BrowserRouter>
      </ToastContext.Provider>
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
